/* index.js */

"use strict";
module.exports = require("./src/Router");
